import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';

const ProtectedRoute = () => {
  /**
   * Verificacion de que el token que existe 
   */
  const token = secureLocalStorage.getItem('token');

  return token ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
